var map = {
	"./background.svg": 5892,
	"./banner-home.png": 9021,
	"./banner-river.png": 9099,
	"./banner-solar-panels-energy.png": 3094,
	"./drone-beach.png": 7357,
	"./logo.png": 4427,
	"./no-cover.png": 8114,
	"./port.png": 5408,
	"./publication-deleted.png": 8720,
	"./rocky-peak-sunset.png": 6656,
	"./welcome-admin.svg": 6075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;